import PropTypes from 'prop-types'
import React from 'react'
import styles from './LoadingIndicator.module.scss'

function LoadingIndicator({ caption = 'Loading ...'}) {
        return <div className={styles.LoadingIndicator}>
                <div className={styles.Indicator}>
                    <div className={styles.Spinner} >
                    </div>
                    <div className={styles.Caption}>{caption}</div>
                </div>
        </div>
}

export default LoadingIndicator;

LoadingIndicator.propTypes = {
  caption: PropTypes.string
}

LoadingIndicator.defaultProps = {
  caption: ''
}
